<template>
  <div class="row">
    <div class="col">
      <card-container
              :title="$router.currentRoute.meta.title"
              :headers="tableHeaders"
              :lastPage="lastPage"
              :totalElements="totalElements"
              :currentPage="getCurrentPage()"
              :clickHandler="pagination">

        <template v-slot:card-header>
          <router-link :to="{ name: `${routePrefix}.create`}" class="btn btn-primary btn-sm"  v-can:add="permissionPrefix">
            <i class="fa fa-plus"></i>
          </router-link>
        </template>

        <template v-slot:card-header-search>
          <search v-model="lastPage" :listHandler="getList"/>
        </template>

        <template v-slot:table-rows>
          <tr v-for="item in items" :key="item.id">
            <td> {{ item.id }} </td>
            <td> {{ item.captainId }} </td>
            <td> {{ item.supplierId }} </td>
            <td> {{ item.supplierName }} </td>
            <td> {{ item.cityId }} </td>
            <td class="text-direction-ltr"> {{ item.startedAt | moment("hh:mm A")  }} </td>
            <td class="text-direction-ltr"> {{ item.finishedAt | moment("hh:mm A")  }} </td>
            <td> {{ item.kmTotalDistance | twoDigitsFraction }} </td>
            <td> {{ item.deliveredOrdersCount }} </td>
            <td> {{ item.totalWorkingMinutes }} </td>
            <td> {{ item.totalWorkingHours }} </td>
            <td class="text-direction-ltr"> {{ item.createdAt | moment("Y-MM-DD")  }} </td>
            <table-item-actions :actions="tableItemActions" :params="{'id':item.id}"/>
          </tr>
          <tr class="text-center" v-if="!items.length">
            <td colspan="999">{{ $t('messages.no_result_found')}}</td>
          </tr>
        </template>
        <template v-slot:card-footer>
          <export-action :crudCode="exportCode" v-can:report="permissionPrefix"></export-action>
        </template>
      </card-container>
    </div>
  </div>
</template>
<script>

  import {mapGetters} from "vuex";
  import { CAPTAIN_WORKING_SUMMARIES_LIST as CRUD_ACTION_LIST} from 'actions/captain_working_summaries';
  import search from "./partials/search";
  const CRUD_CODE="captain_working_summaries";
  const CRUD_PERMISSION_CODE=`captain_working_summary`;

  export default {
    name: "CaptainWorkingSummaryIndex",
    components:{
      search,
    },
    data(){

      return {
        routePrefix: CRUD_CODE,
        transPrefix: CRUD_CODE,
        permissionPrefix: CRUD_PERMISSION_CODE,
        exportCode: `captains/working_summaries`,
        tableHeaders:[
          {
            'title':`fields.id`
          },
          {
            'title':`fields.captain_id`
          },
          {
            'title':`fields.supplier_id`
          },
          {
            'title':`fields.supplier_name`
          },
          {
            'title':`fields.city_id`
          },
          {
            'title':`fields.started_at`
          },
          {
            'title':`fields.finished_at`
          },
          {
            'title':`fields.km_total_distance`
          },
          {
            'title':`fields.delivered_orders_count`
          },
          {
            'title':`fields.total_working_minutes`
          },
          {
            'title':`fields.total_working_hours`
          },
          {
            'title':`fields.created_at`
          },
          {
            'title':`fields.actions`
          }
        ],
        tableItemActions:[
          {
            code:'show',
            route_name:`${CRUD_CODE}.show`,
            can:`${CRUD_PERMISSION_CODE}_can_view`,
          },
        ],
        items: [],
        perPage:20,
        totalElements:0,
        lastPage:0
      }
    },
    mounted() {
      this.getList();
    },
    computed:{
      ...mapGetters([
        "getSearchFilters","getSearchFiltersIfExists","getSearchFiltersSensitized"
      ])
    },
    methods: {
      getList(){
        this.$store.dispatch(CRUD_ACTION_LIST,{
          pageId: this.getCurrentPage()-1,
          ...this.getSearchFiltersSensitized
        }).then(response=>{
          this.items=response.data.data;
          this.perPage=response.data.perPage;
          this.totalElements=response.data.totalElements;
          this.lastPage=response.data.pageCount;
        })
      },
      pagination(page){
        if(page!== this.getCurrentPage()){
          this.$router.push({
            name: `${this.routePrefix}.index`,
            query:{
              page,
              ...this.getSearchFiltersIfExists
            }
          });
          this.getList();
        }
      },
      getCurrentPage(){
        let currentPage=this.$route.query.page??1;
        return parseInt(currentPage>=1?currentPage:1);
      }
    }
  };
</script>
